import {css, cx} from "@panda/css";

import {ContactIcon, DashboardIcon, HeartIcon, TrashIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {View} from "@/features/km_app/types/View";
import {NavigationAmplitudeSource} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {scrollChromeProps} from "@/hooks/use_scroll_expanded_area_into_view";
import {assertNever} from "@/utils/assert_never";

import {INavigationSection, NavigationSectionView} from "../config/navigation_sections";
import {navigationItemActiveStyle} from "../constants/navigation_shared_styles";
import {useTrackNavigationSection} from "../hooks/use_track_navigation_section";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

interface IProps {
    dataTestId?: string;
}

const ICON_FILL = "var(--colors-secondary)";
const ICON_SIZE = "2.4";
const ICON_WRAPPER_COLOR = "transparent";

export const NavigationBottomNav = (props: IProps) => {
    const {dataTestId} = props;

    const {bottomNavSections} = useNavigationSections();
    const trackSection = useTrackNavigationSection(NavigationAmplitudeSource.MOBILE_BOTTOM_NAV);

    return (
        <div className={bottomNavChromeStyle} data-km-bottom-nav-follow="transform" {...scrollChromeProps.bottom}>
            <nav className={bottomNavStyle} data-testid={dataTestId}>
                {bottomNavSections.map((section) => (
                    <NavigationBottomNavItem key={section.view} onNavigate={() => trackSection(section)} section={section} />
                ))}
            </nav>
        </div>
    );
};

interface INavigationBottomNavItemProps {
    onNavigate: () => void;
    section: INavigationSection;
}

const NavigationBottomNavItem = (props: INavigationBottomNavItemProps) => {
    const {onNavigate, section} = props;

    return (
        <NavigationLinkItem
            activeClassName={navigationItemActiveStyle}
            className={cx(bottomNavItemStyle, navigationLinkItemResetStyle)}
            dataTestId={section.testIds.bottomNav}
            onNavigate={onNavigate}
            to={section.path}
        >
            <NavigationBottomNavIcon view={section.view} />

            <Text variant="info_txt_3">{section.labels.bottomNav}</Text>
        </NavigationLinkItem>
    );
};

interface INavigationBottomNavIconProps {
    view: NavigationSectionView;
}

const NavigationBottomNavIcon = (props: INavigationBottomNavIconProps) => {
    const {view} = props;

    switch (view) {
        case View.APPLICATION_SENT:
            return <ContactIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.DASHBOARD:
            return <DashboardIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.DISMISSED:
            return <TrashIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.FAVORITE:
            return <HeartIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        default:
            return assertNever(view);
    }
};

const bottomNavChromeStyle = css({
    backgroundColor: "var(--colors-background-50)",
    borderTopRadius: 3,
    bottom: 0,
    left: 0,
    overflow: "hidden",
    pb: 0.5,
    pointerEvents: "auto",
    position: "fixed",
    px: 0.5,
    transform: "translate3d(0, 0, 0)",
    width: "100%",
    zIndex: "var(--zIndex-navigationChrome)",

    "html[data-km-bottom-nav=hidden] &": {
        pointerEvents: "none",
        transform: "translate3d(0, calc(100% + var(--layout-bottomNavFloatingGap)), 0)"
    }
});

const bottomNavStyle = css({
    alignItems: "stretch",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-4)",
    display: "flex",
    height: "6.4rem",
    justifyContent: "space-around",
    p: 1
});

const bottomNavItemStyle = css({
    alignItems: "center",
    borderRadius: 1,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 0.5,
    height: "4.8rem",
    justifyContent: "center",
    p: 0.5
});
import {css, cx} from "@panda/css";

import {ContactIcon, DashboardIcon, HeartIcon, TrashIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {View} from "@/features/km_app/types/View";
import {NavigationAmplitudeSource} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {scrollChromeProps} from "@/hooks/use_scroll_expanded_area_into_view";
import {assertNever} from "@/utils/assert_never";

import {INavigationSection, NavigationSectionView} from "../config/navigation_sections";
import {navigationItemActiveStyle} from "../constants/navigation_shared_styles";
import {useTrackNavigationSection} from "../hooks/use_track_navigation_section";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

interface IProps {
    dataTestId?: string;
}

const ICON_FILL = "var(--colors-secondary)";
const ICON_SIZE = "2.4";
const ICON_WRAPPER_COLOR = "transparent";

export const NavigationBottomNav = (props: IProps) => {
    const {dataTestId} = props;

    const {bottomNavSections} = useNavigationSections();
    const trackSection = useTrackNavigationSection(NavigationAmplitudeSource.MOBILE_BOTTOM_NAV);

    return (
        <div className={bottomNavChromeStyle} data-km-bottom-nav-follow="transform" {...scrollChromeProps.bottom}>
            <nav className={bottomNavStyle} data-testid={dataTestId}>
                {bottomNavSections.map((section) => (
                    <NavigationBottomNavItem key={section.view} onNavigate={() => trackSection(section)} section={section} />
                ))}
            </nav>
        </div>
    );
};

interface INavigationBottomNavItemProps {
    onNavigate: () => void;
    section: INavigationSection;
}

const NavigationBottomNavItem = (props: INavigationBottomNavItemProps) => {
    const {onNavigate, section} = props;

    return (
        <NavigationLinkItem
            activeClassName={navigationItemActiveStyle}
            className={cx(bottomNavItemStyle, navigationLinkItemResetStyle)}
            dataTestId={section.testIds.bottomNav}
            onNavigate={onNavigate}
            to={section.path}
        >
            <NavigationBottomNavIcon view={section.view} />

            <Text variant="info_txt_3">{section.labels.bottomNav}</Text>
        </NavigationLinkItem>
    );
};

interface INavigationBottomNavIconProps {
    view: NavigationSectionView;
}

const NavigationBottomNavIcon = (props: INavigationBottomNavIconProps) => {
    const {view} = props;

    switch (view) {
        case View.APPLICATION_SENT:
            return <ContactIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.DASHBOARD:
            return <DashboardIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.DISMISSED:
            return <TrashIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        case View.FAVORITE:
            return <HeartIcon fill={ICON_FILL} size={ICON_SIZE} wrapperColor={ICON_WRAPPER_COLOR} wrapperSize={ICON_SIZE} />;
        default:
            return assertNever(view);
    }
};

const bottomNavChromeStyle = css({
    backgroundColor: "var(--colors-background-50)",
    borderTopRadius: 3,
    bottom: 0,
    left: 0,
    overflow: "hidden",
    pb: 0.5,
    pointerEvents: "auto",
    position: "fixed",
    px: 0.5,
    transform: "translate3d(0, 0, 0)",
    width: "100%",
    zIndex: "var(--zIndex-navigationChrome)",

    "html[data-km-bottom-nav=hidden] &": {
        pointerEvents: "none",
        transform: "translate3d(0, calc(100% + var(--layout-bottomNavFloatingGap)), 0)"
    }
});

const bottomNavStyle = css({
    alignItems: "stretch",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-4)",
    display: "flex",
    height: "6.4rem",
    justifyContent: "space-around",
    p: 1
});

const bottomNavItemStyle = css({
    alignItems: "center",
    borderRadius: 1,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 0.5,
    height: "4.8rem",
    justifyContent: "center",
    p: 0.5
});
